module.exports = __webpack_public_path__ + "static/img/img_right@2x.71003b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/img_right@2x.png
// module id = KIPd
// module chunks = 0